import React, { FC, useEffect, useRef, useState } from "react";
import { createUseStyles, useTheme } from "react-jss";
import { motion } from "framer-motion";
import styles from "./styles";

interface Props {
  position?: "top" | "bottom";
  // eslint-disable-next-line react/no-unused-prop-types
  duration?: number;
  text: string | JSX.Element;
  visible?: boolean;
  id: number;
  // eslint-disable-next-line react/no-unused-prop-types
  onComplete?: () => void;
}

const Toast: FC<Props> = (props: Props) => {
  const { position, text, visible, id } = props;
  const toastRef = useRef();
  const theme = useTheme();
  const useStyles = createUseStyles(styles);
  const classes = useStyles({
    theme,
    ...props,
  });

  const [toastPosition, setToastPosition] = useState(0);
  useEffect(() => {
    if (toastRef.current && id) {
      setToastPosition(0);
    }
  }, [id]);

  return (
    <>
      {visible && (
        <motion.button
          initial={{ y: 100, x: "-50%" }}
          animate={{ y: toastPosition, x: "-50%" }}
          transition={{
            ease: toastPosition === 0 ? [0.28, 0.57, 0.2, 1] : "easeIn",
            duration: toastPosition === 0 ? 0.5 : 0.35,
            onComplete: () => {
              setTimeout(() => {
                setToastPosition(100);
              }, 1500);
            },
          }}
          type="button"
          ref={toastRef}
          className={`toast-test ${classes.toast} ${classes[position]}`}
          data-testid="toast-container"
        >
          <span className={classes.text}>{text}</span>
        </motion.button>
      )}
    </>
  );
};

Toast.defaultProps = {
  onComplete: () => {},
  position: "bottom",
  visible: false,
  duration: 5,
};

export default Toast;
